(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tic-wishlist"] && !Shopify.designMode) return;
  try {
    
(function(){
  var KEY = 'tic_wishlist';
  var IS_AR = document.querySelector('[data-tic-wish]')?.dataset.ticWishAr === 'true';

  function read(){
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ return []; }
  }
  function write(list){
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){}
    document.dispatchEvent(new CustomEvent('tic:wishlist:change'));
  }

  // === Inject heart buttons on every product card + on PDP ===
  function attachHeart(target, product){
    if (target.querySelector('[data-tic-wish-toggle]')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tic-wish-heart';
    btn.setAttribute('data-tic-wish-toggle', '');
    btn.setAttribute('aria-label', IS_AR ? 'حفظ في قائمة الرغبات' : 'Save to wishlist');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21s-7-4.35-7-10.5C5 6.91 7.91 4 11.5 4c1.74 0 3.41.81 4.5 2.09C17.09 4.81 18.76 4 20.5 4 24.09 4 27 6.91 27 10.5 27 16.65 20 21 20 21" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" transform="scale(0.5) translate(12 0)"/><path d="M12 21s-7-4.35-7-10.5C5 6.91 7.91 4 11.5 4c1.74 0 3.41.81 4.5 2.09C17.09 4.81 18.76 4 20.5 4 24.09 4 27 6.91 27 10.5 27 16.65 20 21 20 21" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" transform="scale(0.5) translate(0 0)"/></svg>';
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      toggle(product);
      sync();
    });
    target.appendChild(btn);
  }

  function toggle(product){
    var list = read();
    var idx = list.findIndex(function(p){ return p.id === product.id; });
    if (idx > -1) { list.splice(idx, 1); }
    else { list.unshift(product); }
    write(list);
  }

  function isSaved(id){
    return read().some(function(p){ return p.id === id; });
  }

  // Mark all hearts in the DOM as saved/unsaved
  function sync(){
    document.querySelectorAll('[data-tic-wish-toggle]').forEach(function(btn){
      var product = JSON.parse(btn.closest('[data-tic-wish-card]')?.dataset.ticWishProduct || 'null');
      if (!product) return;
      btn.classList.toggle('is-saved', isSaved(product.id));
    });
  }

  // === Render the wishlist grid (only runs when this section is on the page) ===
  var root = document.querySelector('[data-tic-wish]');
  if (root) {
    var grid = root.querySelector('[data-tic-wish-grid]');
    var empty = root.querySelector('[data-tic-wish-empty]');
    var countEl = root.querySelector('[data-tic-wish-count]');

    function render(){
      var list = read();
      if (countEl) {
        countEl.textContent = list.length === 0 ? '' : (IS_AR ? (list.length + ' عناصر محفوظة') : (list.length + ' item' + (list.length === 1 ? '' : 's') + ' saved'));
      }
      if (list.length === 0) {
        grid.innerHTML = '';
        empty.hidden = false;
        return;
      }
      empty.hidden = true;
      grid.innerHTML = list.map(function(p){
        var img = p.image ? '<img src="' + p.image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="320" height="320">' : '';
        return '<div class="tic-wish__card" data-tic-wish-card data-tic-wish-product="' + JSON.stringify(p).replace(/"/g, '&quot;') + '">'
          + '<a href="' + p.url + '" class="tic-wish__card-link">'
          +   '<div class="tic-wish__card-media">' + img + '</div>'
          +   '<div class="tic-wish__card-body">'
          +     '<div class="tic-wish__card-title">' + (p.title || '').replace(/</g, '&lt;') + '</div>'
          +     '<div class="tic-wish__card-price">' + (p.price || '') + '</div>'
          +   '</div>'
          + '</a>'
          + '<button class="tic-wish__remove" data-tic-wish-remove="' + p.id + '" aria-label="' + (IS_AR ? 'إزالة من قائمة الرغبات' : 'Remove from wishlist') + '">×</button>'
          + '</div>';
      }).join('');

      grid.querySelectorAll('[data-tic-wish-remove]').forEach(function(b){
        b.addEventListener('click', function(){
          var id = b.dataset.ticWishRemove;
          var list = read().filter(function(p){ return p.id !== id; });
          write(list);
          render();
        });
      });
    }
    render();
    document.addEventListener('tic:wishlist:change', render);
  }

  // === Auto-attach heart on every product card on collection pages ===
  function bootstrapCards(){
    document.querySelectorAll('.card-wrapper.product-card-wrapper').forEach(function(card){
      if (card.dataset.ticWishCard) return;
      var a = card.querySelector('a[href*="/products/"]');
      var titleEl = card.querySelector('.card__heading a, .card__heading') || a;
      var priceEl = card.querySelector('.price, .price__regular .price-item--regular');
      var imgEl = card.querySelector('img');
      if (!a) return;
      var handle = (a.getAttribute('href').match(/\/products\/([^/?#]+)/) || [])[1];
      if (!handle) return;
      var product = {
        id: handle,
        handle: handle,
        title: (titleEl?.textContent || '').trim(),
        image: imgEl ? imgEl.src : '',
        price: (priceEl?.textContent || '').trim().split(/\s+/).join(' '),
        url: a.getAttribute('href')
      };
      card.setAttribute('data-tic-wish-card', '');
      card.setAttribute('data-tic-wish-product', JSON.stringify(product));
      attachHeart(card, product);
    });
    sync();
  }
  if (document.readyState !== 'loading') bootstrapCards();
  else document.addEventListener('DOMContentLoaded', bootstrapCards);

  // Re-bootstrap when collection pages paginate / filter (Shopify dispatches section reload events)
  document.addEventListener('shopify:section:load', bootstrapCards);
})();

  } catch(e) { console.error(e); }
})();
})();
